import { AwardMeta } from './meta/ss/AwardMeta';
import { ContractMeta } from './meta/ss/ContractMeta';
import { EquipmentMeta } from './meta/ss/EquipmentMeta';
import { EventMeta } from './meta/ss/EventMeta';
import { PRMeta } from './meta/ss/PRMeta';
import { getAwardVerbose } from './verbose/ss/AwardVerbose';
import { getContractVerbose } from './verbose/ss/ContractVerbose';
import { getEquipmentVerbose } from './verbose/ss/EquipmentVerbose';
import { getEventVerbose } from './verbose/ss/EventVerbose';
import { getPRVerbose } from './verbose/ss/PRVerbose';

const AwardVerbose = getAwardVerbose(AwardMeta);
const ContractVerbose = getContractVerbose(ContractMeta);
const EquipmentVerbose = getEquipmentVerbose(EquipmentMeta);
const EventVerbose = getEventVerbose(EventMeta);
const PRVerbose = getPRVerbose(PRMeta);

const a = AwardMeta.length; // 7
const b = a + ContractMeta.length; // 24
const c = b + EquipmentMeta.length; // 9
const d = c + EventMeta.length; // 18
const e = d + PRMeta.length; // 12

// COMMENTED NUMBER RANGE IS THE ARRAY INDECES
export function getCardFromSpringSummerDeckById(cardId: number) {
	let card: any;
	if (cardId < a) {
		card = AwardMeta[cardId]; // 0 - 6
	} else if (cardId < b) {
		card = ContractMeta[cardId - a]; // 7 - 30
	} else if (cardId < c) {
		card = EquipmentMeta[cardId - b]; // 31 - 39
	} else if (cardId < d) {
		card = EventMeta[cardId - c]; // 40 - 57
	} else if (cardId < e) {
		card = PRMeta[cardId - d]; // 58 - 69
	}

	return card;
}

// const a = AwardVerbose.length; // 7
// const b = a + ContractVerbose.length; // 24
// const c = b + EquipmentVerbose.length; // 9
// const d = c + EventVerbose.length; // 18
// const e = d + PRVerbose.length; // 12

// COMMENTED NUMBER RANGE IS THE ARRAY INDECES
export function getCardVerboseFromSpringSummerDeckById(cardId: number) {
	let card;
	if (cardId < a) {
		card = AwardVerbose[cardId]; // 0 - 6
	} else if (cardId < b) {
		card = ContractVerbose[cardId - a]; // 7 - 30
	} else if (cardId < c) {
		card = EquipmentVerbose[cardId - b]; // 31 - 39
	} else if (cardId < d) {
		card = EventVerbose[cardId - c]; // 40 - 57
	} else if (cardId < e) {
		card = PRVerbose[cardId - d]; // 58 - 69
	}

	return card;
}
